import React, { useState } from "react";
import "./subscription.css";
import InputText from "../../../../ui/atoms/inputs/input-text/InputText";
import Loading from "../../../../ui/atoms/loading/Loading";
import MessageBox from "../../../../ui/atoms/message-box/MessageBox";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { wait } from "../../../../core/utils/helpers";
import {
  SubscriptionBankSchema,
  SubscriptionMobileSchema,
} from "../../../../core/utils/validators/authentication";

import { onNewSubscription } from "../../services/settings";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";
import moment from "moment";

const Subscription = ({ inscription_id, setIsRefresh }) => {
  const axiosPrivate = useAxiosPrivate();
  const [isSending, setIsSending] = useState(false);
  const [isShowingMsgBox, setIsShowingMsgBox] = useState(false);
  const [messageData, setMessageData] = useState({ type: "", text: "" });
  //   const [step, setStep] = useState(0);

  const [subscriptionPlan, setSubscriptionPlan] = useState(10);
  const [paymentMode, setPaymentMode] = useState("bank");
  const [cardNumber, setCardNumber] = useState("");
  const [cardExpiryDate, setCardExpiryDate] = useState("");
  const [cardCVC, setCardCVC] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(
      paymentMode === "bank"
        ? SubscriptionBankSchema
        : SubscriptionMobileSchema,
    ),
    defaultValues: {
      inscription_id: inscription_id,
      payment_mode: paymentMode,
    },
  });

  const onSubmit = async (data) => {
    const _start_dates = moment();
    let _end_subscription = null;

    switch (subscriptionPlan) {
      case 3:
        _end_subscription = _start_dates.clone().add(7, "days");
        break;
      case 10:
        // _end_subscription = _start_dates.clone().add(3, "weeks");
        _end_subscription = _start_dates.clone().add(1, "month");
        break;
      case 110:
        _end_subscription = _start_dates.clone().add(12, "months");
        break;

      default:
        console.warn(`Unknown Plan : ${subscriptionPlan}`);
        _end_subscription = null;
    }
    const local_data = {
      inscription_id: data?.inscription_id,
      payment_mode: data?.payment_mode,
      card_number: data?.card_number,
      card_expiry_date: data?.card_expiry_date,
      card_CVC: data?.card_CVC,
      subscription_start: moment(_start_dates).format("YYYY-MM-DD HH:mm:ss"),
      subscription_end: moment(_end_subscription).format("YYYY-MM-DD HH:mm:ss"),
      subscription_plan: subscriptionPlan,
    };
    setIsSending(true);
    await wait(700);
    //
    onNewSubscription(axiosPrivate, local_data)
      .then((response) => {
        setIsSending(false);
        //
        const _data = response?.data;
        if (_data?.status) {
          setIsShowingMsgBox(true);
          setMessageData({ type: "success", text: _data?.message });
          setIsRefresh((prev) => !prev);
          reset();

          const timer = setTimeout(() => {
            setIsShowingMsgBox(false);
            //   setStep((prev) => prev + 1);
            setMessageData({ type: "", text: "" });
          }, 2000);
          return () => clearTimeout(timer);
        } else {
          setIsShowingMsgBox(true);
          setMessageData({ type: "warning", text: _data?.message });
          //
          const timer = setTimeout(() => {
            setIsShowingMsgBox(false);
            setMessageData({ type: "", text: "" });
          }, 3000);
          return () => clearTimeout(timer);
        }
      })
      .catch((error) => {
        setIsSending(false);
        setIsShowingMsgBox(true);
        if (!error?.response) {
          setMessageData({ type: "info", text: "No server response" });
        } else {
          setMessageData({
            type: "warning",
            text: error?.response?.data?.detail?.message,
          });
        }
        const timer = setTimeout(() => {
          setIsShowingMsgBox(false);
          setMessageData({ type: "", text: "" });
        }, 2000);
        return () => clearTimeout(timer);
      });
  };

  return (
    <form className="subscription-form" onSubmit={handleSubmit(onSubmit)}>
      {isShowingMsgBox && (
        <div className="w-full mb-xs">
          <MessageBox type={messageData?.type} msg={messageData?.text} />
        </div>
      )}
      <div className="subscription-packages">
        <div
          className={
            subscriptionPlan === 3
              ? "package-item is-active"
              : "package-item btn-inactive"
          }
          onClick={() => setSubscriptionPlan(3)}
        >
          <p>Daily Format</p>
          <div className="pack-i-row">
            <h1>$3.00</h1>
            <span>/7days</span>
          </div>
        </div>
        <div
          className={
            subscriptionPlan === 10
              ? "package-item is-active"
              : "package-item btn-inactive"
          }
          onClick={() => setSubscriptionPlan(10)}
        >
          <p>Monthly Format</p>
          <div className="pack-i-row">
            <h1>$10.00</h1>
            <span>/A month</span>
          </div>
        </div>
        <div
          className={
            subscriptionPlan === 110
              ? "package-item is-active"
              : "package-item btn-inactive"
          }
          onClick={() => setSubscriptionPlan(110)}
        >
          <p>Yearly Format</p>
          <div className="pack-i-row">
            <h1>$110.00</h1>
            <span>/A year</span>
          </div>
        </div>
      </div>
      <div className="subscription-details">
        <div className="subscription-channels">
          <button
            className={paymentMode === "bank" ? "button btn-active" : "button"}
            onClick={() => {
              reset();
              setPaymentMode("bank");
            }}
          >
            💳 Credit Card
          </button>
          <button
            className={
              paymentMode === "mobile" ? "button btn-active" : "button"
            }
            onClick={() => {
              reset();
              setPaymentMode("mobile");
            }}
          >
            📱 Mobile Payment
          </button>
        </div>
        <div className="field-col">
          <p>
            {paymentMode === "bank" ? "Credit or Debit Cards" : "Phone Number"}*
          </p>
          <InputText
            type={"text"}
            register={register}
            name="card_number"
            title={
              paymentMode === "bank"
                ? "1234 1234 1234 1234"
                : "+XXX XXX XXX XXX"
            }
            error={errors?.card_number?.message}
          />
        </div>
        {paymentMode === "bank" && (
          <React.Fragment>
            <div className="w-full">
              <div className="field-col">
                <p>Expiry*</p>
                <InputText
                  type={"text"}
                  register={register}
                  name="card_expiry_date"
                  title={"MM /YY"}
                  error={errors?.card_expiry_date?.message}
                />
              </div>
              <div className="field-col">
                <p>CVC*</p>
                <InputText
                  type={"text"}
                  register={register}
                  name="card_CVC"
                  title={"123"}
                  error={errors?.card_CVC?.message}
                />
              </div>
            </div>
          </React.Fragment>
        )}
        <p className="p-label">
          By providing your card information, you allow P4MI University to
          charge your card for the payment in accordance with their terms.
        </p>
        <hr />
        {isSending ? (
          <Loading type={"type-1"} />
        ) : (
          <div className="subscription-actions">
            <button className="button btn-cancel" onClick={() => reset()}>
              Cancel
            </button>
            <button className="button btn-confirm" type="submit">
              Proceed Payment
            </button>
          </div>
        )}
      </div>
    </form>
  );
};

export default Subscription;
